import type { RoleName } from '../types/api';
import { ROUTES } from './paths';

/** Pantalla de inicio de cada rol. Un chofer nunca aterriza en el panel administrativo. */
export function homeRouteFor(role: RoleName): string {
  return role === 'ADMIN' ? ROUTES.warehouse.dashboard : ROUTES.driver.orders;
}
